import { IStopSlotActionProvider, SpinMode } from '@cgs/machines';
import { Container, IntervalAction } from '@cgs/wge';

import { CorsicaSpinDelayFactorProvider } from '../corsica-spin-delay-factor.provider';
import { CorsicaStopAnticipationAction } from './corsica-stop-anticipation-action';

export class CorsicaStopActionComponent implements IStopSlotActionProvider {
  private readonly spinDelayFactorProvider: CorsicaSpinDelayFactorProvider;

  constructor(private readonly container: Container) {
    this.spinDelayFactorProvider = new CorsicaSpinDelayFactorProvider(container);
  }

  public getStopSlotAction(_spinMode: SpinMode): IntervalAction {
    return new CorsicaStopAnticipationAction(
      this.container,
      this.spinDelayFactorProvider.spinDelayFactor
    );
  }
}
